<template>
  <div :class="$style['wrapper']">
    <ds-content-header>
      <div slot="left">
        <ds-breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>
    </ds-content-header>
    <div class="columns">
      <div class="column is-6">
        <ds-content-box>
          <div
            slot="header"
            class="content-header"
          >
            <span class="content-title">
              Określ parametry hasła
            </span>
          </div>
          <div slot="content">
            <form
              action=""
              @submit.prevent="onSubmit"
            >
              <div :class="$style['inner']">
                <div>
                  <ds-label class="dark-label">
                    <span slot="content">
                      Ilość znaków
                    </span>
                  </ds-label>
                  <div :class="$style['slider-wrapper']">
                    <ds-slider
                      v-model="passwordLength"
                      :options="sliderOptions"
                    />
                  </div>
                </div>
                <div>
                  <div :class="$style['checkbox-form-group']">
                    <ds-label class="dark-label">
                      <span slot="content">
                        Opcje dodatkowe
                      </span>
                    </ds-label>
                    <div class="checkbox-box">
                      <ds-checkbox-switch
                        :checked="capitalize"
                        @onChecked="onCapitalizeChecked"
                      >
                        <span slot="text">Duże litery</span>
                      </ds-checkbox-switch>
                      <ds-checkbox-switch
                        :checked="numerals"
                        @onChecked="onNumeralsChecked"
                      >
                        <span slot="text">Cyfry</span>
                      </ds-checkbox-switch>
                      <ds-checkbox-switch
                        :checked="special"
                        @onChecked="onSpecialChecked"
                      >
                        <span slot="text">Znaki specjalne</span>
                      </ds-checkbox-switch>
                    </div>
                  </div>
                  <div :class="$style['submit-wrapper']">
                    <ds-button>GENERUJ HASŁO</ds-button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ds-content-box>
      </div>
    </div>

    <div
      v-if="isFetching || generatedPassword || fetchingError"
      class="columns"
    >
      <div class="column is-6">
        <ds-content-box>
          <div
            slot="header"
            class="content-header"
          >
            <span class="content-title">
              Wygenerowane hasło
            </span>
          </div>
          <div slot="content">
            <div
              :class="$style['inner']"
              class="gray-background-inner"
            >
              <ds-loader
                :is-loading="isFetching"
                full-height
              >
                <div
                  :class="$style['password-response-box']"
                  class="input-box"
                >
                  <div>
                    <ds-input
                      :value="generatedPassword"
                      :show-error-box="false"
                      type="password"
                      read-only
                      peek-field
                    />
                  </div>
                  <div>
                    <ds-button @click="onCopy(generatedPassword)">SKOPIUJ DO SCHOWKA</ds-button>
                  </div>
                </div>
                <div v-if="fetchingError">
                  Wystąpił błąd podczas wykonywania komendy.
                </div>
              </ds-loader>
            </div>
          </div>
        </ds-content-box>
      </div>
    </div>
  </div>
</template>

<script>
import ToolboxService from "@/app/dashboard/services/toolbox.service";
import { range } from "lodash";

export default {
  data() {
    return {
      passwordLength: 6,
      capitalize: false,
      numerals: false,
      special: false,
      fetchingError: false,
      isFetching: false,
      generatedPassword: ""
    };
  },
  computed: {
    breadcrumbs() {
      return {
        top: [
          {
            url: {
              name: "password-generator"
            },
            displayName: "Generator haseł"
          }
        ],
        bottom: []
      };
    },
    sliderOptions() {
      return {
        initialValue: 2,
        width: "100%",
        tooltip: false,
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        data: range(6, 33),
        piecewiseStyle: {
          backgroundColor: "#ccc",
          visibility: "visible",
          width: "12px",
          height: "12px"
        },
        piecewiseActiveStyle: {
          backgroundColor: "#3498db"
        }
      };
    }
  },
  methods: {
    onCapitalizeChecked(value) {
      this.capitalize = value;
    },
    onNumeralsChecked(value) {
      this.numerals = value;
    },
    onSpecialChecked(value) {
      this.special = value;
    },
    onCopy(text) {
      this.$copyText(text);
    },
    async onSubmit() {
      this.isFetching = true;
      this.fetchingError = false;
      this.generatedPassword = "";
      let resultData;

      try {
        resultData = await ToolboxService.generatePassword({
          length: this.passwordLength,
          capitalize: this.capitalize,
          numerals: this.numerals,
          special: this.special
        });
        this.generatedPassword = resultData.data;
      } catch (e) {
        this.fetchingError = true;
      }

      this.isFetching = false;
    }
  }
};
</script>

<style lang="scss">
.ping-inp {
  span {
    display: none;
  }
}
</style>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.left-column {
  width: 100%;
  margin-right: 20px;
}
.submit-wrapper {
  margin-top: 30px;
}
.checkbox-form-group {
  margin-top: 20px;
}
.slider-wrapper {
  background-color: $light-blue-silver-color;
  padding: 16px 24px 12px 24px;
  border-radius: 5px;
}
.password-response-box {
  display: flex;
  align-items: center;
  div:first-child {
    width: 100%;
    margin-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/views/password-generator.vue